import MovementView from "@/components/MovementView";

export default function Outward() {
  return <MovementView type="outward" />;
}
